var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_16-Ethereum"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "256.16,358.909 256.16,472.499 395.646,274.453   ",
    style: {
      fill: "#2F3030"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.294,264.834 256.16,39.501 256.16,203.346   ",
    style: {
      fill: "#2F3030"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.16,203.291 256.16,343.114 389.201,264.348   ",
    style: {
      fill: "#131313"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.078,264.834 256.19,39.501 256.19,203.346   ",
    style: {
      fill: "#828384"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.19,203.291 256.19,343.114 122.788,264.348   ",
    style: {
      fill: "#343535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.83,358.909 255.83,472.499 116.354,274.453   ",
    style: {
      fill: "#828384"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.d5ce07a37d401220ab3cbf68b8fedc4b.svg";
export { ForwardRef as ReactComponent };